module.exports = __webpack_public_path__ + "static/media/firebase.c521e7e6.png";